import { selectAssetTypeById } from "@overmap-ai/core"
import { createFileRoute, notFound, Outlet } from "@tanstack/react-router"
import { appStore } from "src/store"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId")({
	component: Outlet,
	loader: ({ params }) => {
		const assetType = selectAssetTypeById(params.assetTypeId)(appStore.getState())
		if (!assetType) throw notFound()
		return assetType
	},
})
